import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/school-admin/emails/types';

const initialState = Immutable.fromJS({
  notificationTypes: [],
  notificationSummary: {},
  notificationType: null,
  isTypesLoading: false,
  isSummaryLoading: false,
  isDisableSwitching: false,
  isEmailTemplateUpdating: false
});

export default reducerCreator(initialState, {
  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_TYPES_LOADING]: (state, { isLoading }) =>
    state.set('isTypesLoading', isLoading),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_SUMMARY_LOADING]: (state, { notificationType, isLoading }) =>
    state
      .set('notificationType', notificationType)
      .set('isSummaryLoading', isLoading),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_DISABLE_SWITCHING]: (state, { isSwitching }) =>
    state.set('isDisableSwitching', isSwitching),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_EMAIL_TEMPLATE_UPDATING]: (state, { isUpdating }) =>
    state.set('isEmailTemplateUpdating', isUpdating),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_EMAIL_TEMPLATE]: (state, { notificationEmailTemplate }) => 
    state.setIn(['notificationSummary', 'emailTemplate'], Immutable.fromJS(notificationEmailTemplate)),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_DISABLED]: (state, { isDisabledNotification }) => 
    state.setIn(['notificationSummary', 'disabled'], isDisabledNotification),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_SUMMARY]: (state, { notificationSummary }) => 
    state.set('notificationSummary', Immutable.fromJS(notificationSummary)),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_TYPES]: (state, { notificationTypes }) => 
    state.set('notificationTypes', Immutable.fromJS(notificationTypes)),

  [types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_RESET_SUMMARY]: () =>
    initialState
});


// WEBPACK FOOTER //
// ./src/reducers/school-admin/emails.js